import { render } from "./ListeGroupeTaxe.vue?vue&type=template&id=1675b296&ts=true"
import script from "./ListeGroupeTaxe.vue?vue&type=script&lang=ts"
export * from "./ListeGroupeTaxe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__